import { BaseApi as Base } from '@micromag/data';

import OrganisationsMembersApi from './OrganisationsMembers';
import OrganisationsContacts from './OrganisationsContacts';

class OrganisationsApi extends Base {
    constructor(opts = {}) {
        super(opts);
        this.members = new OrganisationsMembersApi(opts);
        this.contacts = new OrganisationsContacts(opts);
    }

    find(id) {
        return this.requestGet(this.route('organisations.show', { organisation: id }));
    }

    findBySlug(slug) {
        return this.requestGet(this.route('organisations.show', { organisation: slug }));
    }

    get() {
        return this.requestGet(this.route('organisations.index'));
    }

    create(data) {
        return this.requestPost(this.route('organisations.store'), data);
    }

    update(data) {
        return this.requestPost(this.route('organisations.update'), data);
    }

    delete() {
        return this.requestDelete(this.route('organisations.destroy'));
    }
}

export default OrganisationsApi;
